import { render, staticRenderFns } from "./ClassChooseWidget.vue?vue&type=template&id=4d09f0b2&scoped=true&"
import script from "./ClassChooseWidget.vue?vue&type=script&lang=js&"
export * from "./ClassChooseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09f0b2",
  null
  
)

export default component.exports